import {
  Button,
  Heading,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text
} from "@chakra-ui/react";

interface DownloadCSVProps {
  isOpen: boolean;
  onClose: () => void;
  isDownloadingCSV: boolean;
  isDownloadingPDF: boolean;
  handleDownloadClick: () => void;
}

export default function DownloadCSV({
  isOpen,
  onClose,
  isDownloadingCSV,
  isDownloadingPDF,
  handleDownloadClick
}: DownloadCSVProps) {
  return (
    <Modal
      size="lg"
      isCentered
      closeOnOverlayClick={false}
      motionPreset="slideInBottom"
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent pt={6} pb={4} px={4}>
        <ModalHeader>
          <Heading color="secondary.600" fontWeight={600} fontSize="xl">
            Download CSV files
          </Heading>
        </ModalHeader>
        <ModalCloseButton top={6} right={6} />
        <ModalBody>
          <Stack spacing={4}>
            <Text fontWeight={500} fontSize={14}>
              Your selected items are ready for CSV download. They will also be
              sent to your email address.
            </Text>
          </Stack>
        </ModalBody>
        <ModalFooter mt={2} mb={3} px={4} w="full">
          <HStack w="full" justify="flex-end">
            <Button w={157} size="sm" h={9} variant="outline" onClick={onClose}>
              Cancel
            </Button>

            <Button
              onClick={handleDownloadClick}
              w={157}
              size="sm"
              h={9}
              isLoading={isDownloadingCSV || isDownloadingPDF}
            >
              Download
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
